import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import { handleAuthToken } from '../handlers/auth-token.js';
import { handleBridgeIdentified } from '../handlers/bridge-identified.js';
import { handleInstalledAgentAuthSync } from '../handlers/installed-agent-auth-sync.js';
import { handleBridgeHeartbeatAck } from '../../connection/heartbeat/ack.js';

export function dispatchBridgeConnectionMessage(
  msg: Extract<
    ApiToBridgeMessage,
    { type: 'auth_token' | 'bridge_identified' | 'installed_agent_auth_sync' | 'ha' }
  >,
  deps: MessageHandlerDeps
): void {
  switch (msg.type) {
    case 'auth_token':
      handleAuthToken(msg, deps);
      break;
    case 'bridge_identified':
      handleBridgeIdentified(msg, deps);
      break;
    case 'installed_agent_auth_sync':
      handleInstalledAgentAuthSync(msg, deps);
      break;
    case 'ha':
      handleBridgeHeartbeatAck(msg, deps);
      break;
  }
}
